var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNews2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 159,
    height: 158,
    viewBox: "0 0 159 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.34912,
    y: 1.96289,
    width: 156,
    height: 155,
    rx: 73,
    stroke: "white",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_701_423)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.8567 66.0132H75.4591C74.102 66.0132 73.002 67.1486 73.002 68.5496C73.002 69.9504 74.1018 71.0859 75.4591 71.0859H90.8567C92.2147 71.0859 93.3139 69.9506 93.3139 68.5496C93.3137 67.1486 92.2138 66.0132 90.8567 66.0132Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7536 78.272H75.4591C74.102 78.272 73.002 79.4073 73.002 80.8083C73.002 82.2092 74.1018 83.3447 75.4591 83.3447H96.7536C98.1107 83.3447 99.2108 82.2093 99.2108 80.8083C99.2108 79.4073 98.1107 78.272 96.7536 78.272Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.892 50.1187H64.4024C63.0453 50.1187 61.9453 51.254 61.9453 52.655V76.581H57.6046C52.5012 76.581 48.3496 80.8674 48.3496 86.1345V100.253C48.3496 105.521 52.5012 109.807 57.6046 109.807C58.0222 109.807 58.4334 109.778 58.8356 109.722H99.3748C105.426 109.722 110.35 104.64 110.35 98.3935V52.655C110.35 51.254 109.25 50.1187 107.892 50.1187ZM61.9454 100.253C61.9454 102.427 60.4376 104.245 58.445 104.65H57.6047V104.734C55.2107 104.734 53.2638 102.724 53.2638 100.253V86.1345C53.2638 83.6642 55.2115 81.6537 57.6047 81.6537H61.9455V100.253H61.9454ZM105.436 98.3934C105.436 101.785 102.661 104.65 99.3748 104.65H65.8202C66.4844 103.333 66.8595 101.838 66.8595 100.253V55.1913H105.436V98.3934Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.8567 89.771H75.4591C74.102 89.771 73.002 90.9064 73.002 92.3074C73.002 93.7082 74.1018 94.8437 75.4591 94.8437H90.8567C92.2147 94.8437 93.3139 93.7084 93.3139 92.3074C93.3137 90.9064 92.2138 89.771 90.8567 89.771Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_701_423"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 64,
    fill: "white",
    transform: "translate(48.3496 47.9629)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNews2);
export default __webpack_public_path__ + "static/media/news2.5e391558a8681dee5fc0e921a5548d8e.svg";
export { ForwardRef as ReactComponent };